export default "__VITE_ASSET__Dby23wSd__"